import { render, staticRenderFns } from "./aufgaben.vue?vue&type=template&id=891ae03e"
import script from "./aufgaben.vue?vue&type=script&lang=js"
export * from "./aufgaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports